import { Route, Routes } from "react-router-dom";

import SaleEditPage from "./pages/SaleEditPage";

import IndexPage from "@/pages/index";
import DocsPage from "@/pages/docs";
import PricingPage from "@/pages/pricing";
import BlogPage from "@/pages/blog";
import AboutPage from "@/pages/about";
import BooksPage from "@/pages/bookList";
import AddBookPage from "@/pages/bookadd";
import ViewBook from "@/pages/bookview";
import InventoryForm from "@/pages/inventoryform";
import InventoryPage from "@/pages/InventoryPage";
import InventoryView from "@/pages/InventoryView";
import InventoryEdit from "@/pages/InventoryEdit";
import SalesPage from "@/pages/SalesPage";
import AddSalePage from "@/pages/AddSalePage";
import { EditBookPage as BookEdit } from "@/pages/bookEdit";
import UserManagementPage from "@/pages/UserManagementPage";
import LoginPage from "@/pages/LoginPage";
import CreateClientPage from "@/pages/CreateClientPage";
import ClientsPage from "@/pages/ClientsPage";
import { RtlProvider } from "@/hooks/RtlContext";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import EditUserPage from "@/pages/EditUserPage";
import UserViewPage from "@/pages/UserViewPage";
import OrderPage from "@/pages/order";
import OrderHistoryPage from "@/pages/OrderHistoryPage";
import ViewSalePage from "@/pages/ViewSalePage";
import AuditPage from "@/pages/AuditPage";
import LogsPage from "@/pages/LogsPage";

function App() {
  return (
    <AuthProvider>
      <RtlProvider>
        <Routes>
          {/* Protected Routes */}
          <Route
            element={
              <ProtectedRoute roles={["admin", "user", "superadmin"]}>
                <IndexPage />
              </ProtectedRoute>
            }
            path="/"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "user", "superadmin"]}>
                <IndexPage />
              </ProtectedRoute>
            }
            path="/home"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "user", "superadmin"]}>
                <DocsPage />
              </ProtectedRoute>
            }
            path="/docs"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "user", "superadmin"]}>
                <PricingPage />
              </ProtectedRoute>
            }
            path="/pricing"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "user", "superadmin"]}>
                <BlogPage />
              </ProtectedRoute>
            }
            path="/blog"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "user", "superadmin"]}>
                <AboutPage />
              </ProtectedRoute>
            }
            path="/about"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "user", "superadmin"]}>
                <BooksPage />
              </ProtectedRoute>
            }
            path="/bookList"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "user", "superadmin"]}>
                <AddBookPage />
              </ProtectedRoute>
            }
            path="/bookAdd"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "user", "superadmin"]}>
                <ViewBook />
              </ProtectedRoute>
            }
            path="/book/view/:id"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "user", "superadmin"]}>
                <BookEdit />
              </ProtectedRoute>
            }
            path="/bookEdit/:id"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "user", "superadmin"]}>
                <InventoryPage />
              </ProtectedRoute>
            }
            path="/inventory"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "user", "superadmin"]}>
                <InventoryForm />
              </ProtectedRoute>
            }
            path="/inventory/add"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "user", "superadmin"]}>
                <InventoryView />
              </ProtectedRoute>
            }
            path="/inventory/view/:id"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "user", "superadmin"]}>
                <InventoryEdit />
              </ProtectedRoute>
            }
            path="/inventory/edit/:id"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "user", "superadmin"]}>
                <SalesPage />
              </ProtectedRoute>
            }
            path="/sales"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "user", "superadmin"]}>
                <AddSalePage />
              </ProtectedRoute>
            }
            path="/addSale"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "user", "superadmin"]}>
                <ViewSalePage />
              </ProtectedRoute>
            }
            path="/sale/View/:id"
          />
          <Route element={<LoginPage />} path="/login" />
          <Route
            element={
              <ProtectedRoute roles={["superadmin"]}>
                <ClientsPage />
              </ProtectedRoute>
            }
            path="/client"
          />
          <Route
            element={
              <ProtectedRoute roles={["superadmin"]}>
                <CreateClientPage />
              </ProtectedRoute>
            }
            path="/addClient"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "user", "superadmin"]}>
                <OrderPage />
              </ProtectedRoute>
            }
            path="/orders"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "user", "superadmin"]}>
                <OrderHistoryPage />
              </ProtectedRoute>
            }
            path="/order-history"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "superadmin"]}>
                <AuditPage />
              </ProtectedRoute>
            }
            path="/audit"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "superadmin"]}>
                <UserManagementPage />
              </ProtectedRoute>
            }
            path="/users"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "superadmin"]}>
                <EditUserPage />
              </ProtectedRoute>
            }
            path="/edit-user/:userId"
          />
          <Route
            element={
              <ProtectedRoute roles={["admin", "superadmin"]}>
                <UserViewPage />
              </ProtectedRoute>
            }
            path="/user/:userId"
          />
          <Route element={<SaleEditPage />} path="/saleEdit/:id" />
          <Route
            element={
              <ProtectedRoute roles={["admin", "superadmin"]}>
                <LogsPage />
              </ProtectedRoute>
            }
            path="/logs"
          />
        </Routes>
      </RtlProvider>
    </AuthProvider>
  );
}

export default App;
